exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.card-body[data-v-203bf962] {\n    padding: 10px;\n    max-height: 600px;\n}\n", ""]);

